import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import Picture from '../Picture';

function ContributorRow({ imageSource, name, litterCount, rowNumber }) {
    return (
        <div className="tileCard d-flex flex-row align-items-center">
            <div className="count">{rowNumber}</div>
            <div className="col">
                <div className="d-flex align-items-center">
                    <div className="col">
                        <Picture source={imageSource} variant={'Small'} />
                    </div>
                    <div className="col-10">
                        <div className="userName">{name}</div>
                    </div>
                </div>
            </div>
            <div className="col-2">
                <div className="info">{`${litterCount} Pieces`}</div>
            </div>
        </div>
    );
}

ContributorRow.propTypes = {
    // To give the source for the img to the picture component
    imageSource: PropTypes.string,

    // The name of the contributor to be displayed on the row
    name: PropTypes.string,

    // The number of litter pieces displayed against the contributor
    litterCount: PropTypes.string,

    // The row to be displayed (specifically for the scrolling component)
    rowNumber: PropTypes.number,
};

ContributorRow.defaultProps = {
    imageSource: null,
    name: null,
    litterCount: null,
    rowNumber: null,
};

export default ContributorRow;
